import NextImage from '@/components/NextImage';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function SeamlessUpdates() {
    const { useLang } = useGlobal();
    const { t } = useLang('PoweroceanSinglePhase.SeamlessUpdates');
    return (
        <div className={`${styles.seamlessUpdates}`}>
            <div className="solution-item">
                <div className="text-box">
                    <div className="sub-title">{t('label')}</div>
                    <div className="title">{t('title')}</div>
                    <div className="desc">{t('desc')}</div>
                </div>

                <div className="container">
                    <div className="bg-img">
                        <NextImage src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713525273011/Update.png'} alt={t('title')} />
                    </div>
                    <div className="bg-img-h5">
                        <NextImage src={'https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713524451537/Blackout3-tuya.jpg'} alt={t('title')} />
                    </div>
                    <div className="bg-img">
                        <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713524927395/Blackout2-tuya.jpg" alt={t('title')} />
                    </div>
                    <div className="bg-img-h5">
                        <NextImage src="https://ecoflow-service-us-cdn.ecoflow.com/upload/image/1713524446070/Blackout2-tuya.jpg" alt={t('title')} />
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
